import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

import Home from '../views/Home.vue';
import Post from '../views/Post.vue';
import Stream from '../views/Stream.vue';
import TermOfUse from '../views/TermOfUse.vue';
import PrivacyPolicy from '../views/PrivacyPolicy.vue';
import About from '../views/About.vue';
import Settings from '../views/Settings.vue';
import UserPage from '../views/UserPage.vue';
import Playlist from '../views/Playlist.vue';
import Login from '../views/Login.vue';
import Logout from '../views/Logout.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      title: 'midies',
      displayName: 'midies'
    }
  },
  {
    path: '/post/:postId',
    name: 'post',
    component: Post,
    meta: {
      displayName: '投稿'
    }
  },
  {
    path: '/stream/:postId?',
    name: 'stream',
    component: Stream,
    meta: {
      title: '配信 - midies',
      displayName: '配信',
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: {
      title: '設定 - midies',
      displayName: '設定',
      requiresAuth: true
    }
  },
  {
    path: '/user/:userId?',
    name: 'user-page',
    component: UserPage,
    meta: {
      displayName: 'ユーザーページ'
    }
  },
  {
    path: '/playlist/:listId?',
    name: 'playlist',
    component: Playlist,
    meta: {
      displayName: 'プレイリスト'
    }
  },
  {
    path: '/term-of-use',
    name: 'term-of-use',
    component: TermOfUse,
    meta: {
      title: '利用規約 - midies',
      displayName: '利用規約'
    }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicy,
    meta: {
      title: 'プライバシーポリシー - midies',
      displayName: 'プライバシーポリシー'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      title: '当サイトについて - midies',
      displayName: '当サイトについて'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'ログイン - midies',
      displayName: 'midies'
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
    meta: {
      title: 'ログアウト - midies',
      displayName: 'midies'
    }
  },
  {
    path: '*',
    redirect: 'home'
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const isAuthed = store.state.userData.isAuthed;
  if (store.state.firebaseState.isConnected && !confirm('接続が解除されます。\n本当にページを移動しますか？')) {
    next(false);
    return;
  }
  if (isAuthed || to.matched.some(record => !record.meta.requiresAuth)) {
    if (to.name === 'user-page' && !to.params.userId && store.state.userData.uid) {
      next({
        name: 'user-page',
        params: {
          userId: store.state.userData.uid
        }
      });
    } else if ((to.name === 'login' && isAuthed) || (to.name === 'logout' && !isAuthed)) {
      next({ name: 'home' });
    } else {
      next();
    }
  } else {
    next({
      name: 'login',
      query: { redirect: to.fullPath }
    });
  }
});

export default router;
